import { render } from "./landingPage-block1.vue?vue&type=template&id=53949b62&scoped=true"
import script from "./landingPage-block1.vue?vue&type=script&lang=js"
export * from "./landingPage-block1.vue?vue&type=script&lang=js"

import "../pages/landing-page.scss?vue&type=style&index=0&lang=scss&external"
import "./landingPage-block1.vue?vue&type=style&index=1&id=53949b62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53949b62"]])

export default __exports__